import { useCallback, useMemo, useState } from "react";
import type { ReactNode } from "react";
import { SOrdnerOverviewContext } from "@/sordnerOverview/sordnerOverviewContextValue";
import { SOrdnerOverviewDialog } from "@/sordnerOverview/SOrdnerOverviewDialog";

export function SOrdnerOverviewProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeId, setActiveId] = useState<number | null>(null);

  const open = useCallback((sordnerId: number) => {
    const id = Number(sordnerId);
    if (!Number.isFinite(id) || id <= 0) return;
    setActiveId(id);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setActiveId(null);
  }, []);

  const value = useMemo(
    () => ({ open, close, isOpen, activeId }),
    [open, close, isOpen, activeId],
  );

  return (
    <SOrdnerOverviewContext.Provider value={value}>
      {children}
      <SOrdnerOverviewDialog open={isOpen} sordnerId={activeId} onClose={close} />
    </SOrdnerOverviewContext.Provider>
  );
}
